<template>
  <v-card tolbar dark class="organization locations">
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">Locations</div>
      <v-spacer />
      <can I="edit" a="Organization">
        <v-btn round @click="add" color="secondary">
          <v-icon left>mdi-plus</v-icon> Add Location
        </v-btn>
      </can>
    </v-toolbar>

    <v-list>
      <v-list-tile v-for="(location, i) in organization.locations" :key="`location-${i}`" avatar>
        <v-list-tile-avatar>
          <v-avatar v-if="location.countryCode" size="22px">
            <img
              :class="
                `flag-icon-background flag-icon-squared flag-icon-${location.countryCode.toLowerCase()}`
              "
              style="padding: 16px"
            />
          </v-avatar>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title> {{ location.address }} </v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <can I="edit" a="Organization">
            <v-menu left>
              <v-btn icon small flat fab slot="activator" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-card>
                <v-card-title>Remove {{ location.address }}?</v-card-title>
                <v-card-actions>
                  <v-btn @click="remove(location.id)" block color="error">
                    Remove
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </can>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-card-text v-if="adding">
      <v-text-field v-model="address" label="Address" required />
    </v-card-text>
    <v-card-actions v-if="adding"
      ><v-spacer />
      <v-btn flat @click="cancel" color="grey">Cancel</v-btn>
      <v-btn @click="create" color="primary">Add</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  data() {
    return { adding: false, address: '' }
  },
  computed: mapGetters({
    organization: 'admin/organizations/find',
  }),
  methods: {
    add() {
      this.adding = true
    },
    cancel() {
      this.adding = false
      this.address = ''
    },
    create() {
      this.$store
        .dispatch('admin/organizations/createLocation', {
          organization: { id: this.organization.id },
          address: this.address,
        })
        .then(this.cancel)
    },
    remove(id) {
      this.$store.dispatch('admin/organizations/removeLocation', {
        organization: { id: this.organization.id },
        id: id,
      })
    },
  },
}
</script>
